import NewsletterSection from './NewsletterSection';

export default NewsletterSection;
